<nav class="tp-nav">
  <div class="tp-nav-section">Mon entreprise</div>

  <a routerLink="/merchant/transactions" routerLinkActive="active" class="tp-nav-item" (click)="newMessage('Mes transactions')">
    <img src="assets/qr.svg" alt="" class="tp-nav-icon">
    <span>Mes transactions</span>
  </a>

  <a routerLink="/merchant/solde" routerLinkActive="active" class="tp-nav-item" (click)="newMessage('Mon solde')">
    <img src="assets/cash.svg" alt="" class="tp-nav-icon">
    <span>Mon solde</span>
  </a>

  <a routerLink="/merchant/qr-code" routerLinkActive="active" class="tp-nav-item" (click)="newMessage('Mon Qr-Code')">
    <img src="assets/qr-code.svg" alt="" class="tp-nav-icon">
    <span>Mon Qr code</span>
  </a>

  <a routerLink="/merchant/kids" routerLinkActive="active" class="tp-nav-item" (click)="newMessage('Mes boutiques & caisses')">
    <img src="assets/add.svg" alt="" class="tp-nav-icon">
    <span>Mes Boutiques / Caisses</span>
  </a>

  <a routerLink="/merchant/bons" routerLinkActive="active" class="tp-nav-item" (click)="newMessage('Mes bons cadeaux')">
    <img src="assets/cash.svg" alt="" class="tp-nav-icon">
    <span>Mes bons cadeaux</span>
  </a>

  <div class="tp-nav-section">Préférences</div>

  <a routerLink="/merchant/aide" routerLinkActive="active" class="tp-nav-item" (click)="newMessage('Aide')">
    <img src="assets/help.svg" alt="" class="tp-nav-icon">
    <span>Besoin d'aide</span>
  </a>

  <a routerLink="/merchant/profil" routerLinkActive="active" class="tp-nav-item" (click)="newMessage('Profil')">
    <img src="assets/profile.svg" alt="" class="tp-nav-icon">
    <span>Mon profil</span>
  </a>

  <div class="tp-nav-footer">
    <button type="button" class="tp-nav-item tp-nav-logout" (click)="logout()">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line>
      </svg>
      <span>Déconnexion</span>
    </button>
  </div>
</nav>